import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29df9525"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "profile-container" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "links" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://getindya.com/proteccion-de-datos-gdpr/",
  target: "_blank",
  class: "politics"
}, "Política de protección de datos", -1))
const _hoisted_7 = { class: "modal padding" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Espera", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Recuerda que si cancelas tu suscripción "),
  /*#__PURE__*/_createElementVNode("strong", null, " perderás tu precio especial y tus descuentos pendientes de canjear del programa de referidos "),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ¿Quieres cancelar igualmente? ", -1))
const _hoisted_11 = { class: "modal" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Paramos aquí", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Gracias por confiar en INDYA."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Vuelve siempre que quieras."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nos alegrará volver a verte con hambre de retos. ")
], -1))
const _hoisted_15 = { class: "modal" }
const _hoisted_16 = { class: "leave" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "¿Te quedas?", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Para el equipo sería un subidón que volvieras ", -1))
const _hoisted_20 = { class: "modal" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title line1" }, "¡Se queda!", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "¡Qué grande!", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Gracias por no rendirte. Tu suscripción sigue como la dejaste ", -1))
const _hoisted_24 = { class: "modal" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "¡Todo listo!", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Pago realizado con éxito ", -1))
const _hoisted_27 = { class: "modal" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "ATENCIÓN", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Reintento de pago fallido, revisa tu tarjeta ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_UserImage = _resolveComponent("UserImage")!
  const _component_ProfileResubscription = _resolveComponent("ProfileResubscription")!
  const _component_PersonalData = _resolveComponent("PersonalData")!
  const _component_PaymentMethod = _resolveComponent("PaymentMethod")!
  const _component_Payments = _resolveComponent("Payments")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_CancelStep2 = _resolveComponent("CancelStep2")!
  const _component_TimeOut = _resolveComponent("TimeOut")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header, null, {
        default: _withCtx(() => [
          _createTextVNode("MI FICHA")
        ]),
        _: 1
      }),
      _createVNode(_component_UserImage, {
        image: _ctx.user?.userImage
      }, null, 8, ["image"]),
      (_ctx.showPaymentReview)
        ? (_openBlock(), _createBlock(_component_ProfileResubscription, {
            key: 0,
            onProfileRetryPayment: _ctx.profileRetryPayment
          }, null, 8, ["onProfileRetryPayment"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PersonalData, {
            name: _ctx.user?.name,
            email: _ctx.user?.email || ''
          }, null, 8, ["name", "email"]),
          (_ctx.subscriptionCard)
            ? (_openBlock(), _createBlock(_component_PaymentMethod, {
                key: 0,
                "apple-in-app": _ctx.appleInApp,
                error: _ctx.paymentMethodError,
                cardNumber: _ctx.subscriptionCard.cardNumber,
                expire: _ctx.subscriptionCard.$expiration,
                onSave: _ctx.save
              }, null, 8, ["apple-in-app", "error", "cardNumber", "expire", "onSave"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.currentSubscription)
            ? (_openBlock(), _createBlock(_component_Payments, {
                key: 0,
                "apple-in-app": _ctx.appleInApp,
                currentSubscription: _ctx.currentSubscription,
                user: _ctx.user,
                subscriptionCard: _ctx.subscriptionCard,
                onReenableSubscription: _ctx.askReenableSubscription
              }, null, 8, ["apple-in-app", "currentSubscription", "user", "subscriptionCard", "onReenableSubscription"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.canCancelSubscription)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              class: "cancel",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCancelModal && _ctx.openCancelModal(...args)), ["prevent"]))
            }, "Cancelar suscripción"))
          : _createCommentVNode("", true),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.cancel.Step1,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cancel.Step1) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel.Step1 = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" No, seguir con mi suscripción ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  variant: "turquoise outlined",
                  onClick: _ctx.continueCancelSubscription
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sí, cancelar mi suscripción ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.cancel.Step2,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cancel.Step2) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CancelStep2, {
          modelValue: _ctx.selectedMotive,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedMotive) = $event)),
          motives: _ctx.motives,
          onNext: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelSubscription(false))),
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancel.Step2 = false))
        }, null, 8, ["modelValue", "motives"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.cancel.Step3,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cancel.Step3) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TimeOut, {
          onTimeoutClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel.Step3 = false)),
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancelSubscription(true))),
          onTimeOutPlanPurchase: _ctx.timeOutPlanPurchase,
          "can-cancel-subscription": _ctx.canCancelSubscription,
          currentSubscription: _ctx.currentSubscription
        }, null, 8, ["onTimeOutPlanPurchase", "can-cancel-subscription", "currentSubscription"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.cancel.Step4,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cancel.Step4) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: require('@/assets/images/exit.svg'),
                alt: "salir"
              }, null, 8, _hoisted_12),
              _hoisted_13,
              _createElementVNode("div", null, " Cuando finalice tu mensualidad el día " + _toDisplayString(_ctx.subscriptionEndDate) + " ya no se te realizará nungún cargo más en tu cuenta. ", 1),
              _hoisted_14,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise textblack",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancel.Step4 = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ok ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.reenableSubscriptionModals.Step1,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.reenableSubscriptionModals.Step1) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.reenableSubscriptionModals.Step1 = false), ["prevent"]))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/exit.svg'),
                    alt: "salir"
                  }, null, 8, _hoisted_17)
                ])
              ]),
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise textblack",
                  onClick: [_ctx.reenableSubscription, _ctx.logResubscriptionConfirmed]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Me quedo ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.reenableSubscriptionModals.Step2,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.reenableSubscriptionModals.Step2) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise textblack",
                  onClick: _ctx.closeReenableSubscriptionModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ¡Vamos! ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.profileRetryPaymentStatus.successful,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.profileRetryPaymentStatus.successful) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise textblack",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.profileRetryPaymentStatus.successful = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ok ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.profileRetryPaymentStatus.failed,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.profileRetryPaymentStatus.failed) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _hoisted_29,
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  variant: "turquoise textblack",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.profileRetryPaymentStatus.failed = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ok ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}